import React, { Component } from 'react';
import ReactDOM from 'react-dom';

const modalRoot = document.getElementById('overlay-root');

export class OverlayPortal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.element = document.getElementsByTagName('body')[0];
    this.element.classList.add('hide-bar');
  }

  componentDidMount() {
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
    this.element.classList.remove('hide-bar');
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}
